<template>
  <div>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch color="success" v-model="form.status" style="width: 60px">
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Aplicar ao Endosso</span>
          <vs-switch
            color="success"
            v-model="form.applyToEndorsement"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="form.name"
            v-validate="{ required: true, min: 3 }"
            :state="validateState('Nome')"
            :class="validateStateClass('Nome')"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Exigência %</span>
          <vs-input
            type="number"
            size="large"
            class="w-full"
            name="Exigência"
            id="Exigência"
            v-model="form.requirement"
            icon-pack="feather"
            icon="icon-percent"
            v-validate="'required|between:0,100'"
            :state="validateState('Exigência')"
            :class="validateStateClass('Exigência')"
          />
        </div>
      </div>

      <ErrorsAlert :errors="errors" />

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import ErrorsAlert from '../../components/ErrorsAlert.vue';
import BotaoSubmit from '../../components/BotaoSubmit';

import utilsList from '../../utils/list/index';
import notify from '../../utils/notify';
import services from '../../services/life-api';

export default {
  name: 'formPriorInspection',
  components: { ErrorsAlert, BotaoSubmit },
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
  },
  data() {
    return {
      controller: 'prior-inspections',
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      form: {
        id: null,
        name: null,
        requirement: 0,
        status: false,
        applyToEndorsement: false,
      },
      aguardeCadastro: false,
    };
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
  },
  methods: {
    preencheForm() {
      if (this.dados.id) {
        this.form.id = this.dados.id;
        this.form.name = this.dados.name;
        this.form.requirement = this.dados.requirement;
        this.form.status = this.dados.deletedAt === null;
        this.form.applyToEndorsement = this.dados.applyToEndorsement;
      } else {
        this.resetForm();
      }
    },
    async onSubmit() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        const body = {
          name: this.form.name,
          requirement: +this.form.requirement,
          status: Boolean(this.form.status),
          applyToEndorsement: Boolean(this.form.applyToEndorsement),
        };
        try {
          this.aguardeCadastro = true;
          await services.update(this.controller, body, this.form.id);
          notify.notifySuccess(this.$vs, 'Operação Realizada com sucesso');
          this.$emit('concluido');
        } catch (error) {
          console.log(error);
          notify.notifyFail(this.$vs, error.response.data.message);
        } finally {
          this.aguardeCadastro = false;
        }
      }
    },
    resetForm() {
      this.formCadastro = {
        id: null,
        name: null,
        requirement: 0,
        status: true,
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },
};
</script>
<style></style>
